export enum VendorMigrationTab {
  OpenTofu = "OpenTofu",
  Terragrunt = "Terragrunt",
}
